window.User = (function () {
    function User(id, u, c, p, v) {
        if (v === void 0) { v = true; }
        this.username = u;
        this.id = id;
        this.color = c;
        this.permstr = p;
        this.perms = p.split(p.indexOf("\f") < 0 ? ' ' : "\f");
        this.visible = v;
    }
    User.prototype.EvaluatePermString = function () {
        this.perms = this.permstr.split(this.permstr.indexOf("\f") < 0 ? ' ' : "\f");
    };
    User.prototype.getRank = function () {
        return parseInt(this.perms[0]);
    };
    User.prototype.canModerate = function () {
        return this.perms[1] == "1";
    };
    User.prototype.isBot = function() {
        return this.id === '-1';
    };
    User.prototype.getAvatarUrl = function() {
        return this.isBot()
            ? '/images/alert.png'
            : `${process.env.AMI_FII_URL}/assets/avatar/${encodeURIComponent(this.id)}?res=160&ver=9001`;
    };
    return User;
})();

window.UserContext = (function () {
    function UserContext() {
    }
    UserContext.users = {};
    return UserContext;
})();
